<div class="sidebar included">
	<app-sidebar-header [title]="'Rent a Car'"></app-sidebar-header>

	<div #sidebar__body class="sidebar__body sl--scrollable">
		<p>"Rent a Car" information!</p>
	</div>

	<div #sidebar__footer class="sidebar__footer "></div>
</div>
